import { useCallback } from 'react';
import useAxios from '@Apis/useAxios';
import {
    GET_MEMBER_CYCLE_PURCHASE_LIST,
    GET_MEMBER_CYCLE_PURCHASE_PRODUCTS,
    POST_MEMBER_CYCLE_PURCHASE_CHANGE_FLAVOR,
    GET_MEMBER_CYCLE_PURCHASE_PENDING_CHANGES,
    GET_MEMBER_CYCLE_PURCHASE_EFFECTION,
    DELETE_MEMBER_CYCLE_PURCHASE_EFFECTION,
} from '@Apis/apiPath';

/**
 * 循環訂單相關 API hook
 * loading / error 由 useAxios 全域機制自動處理（Redux loading + snackbar）
 */
const useMemberCyclePurchaseApi = () => {
    const Axios = useAxios();

    /** 取得會員循環訂單清單 */
    const getMemberCyclePurchaseListApi = useCallback(
        async () => {
            const resp = await Axios.get(GET_MEMBER_CYCLE_PURCHASE_LIST);
            return resp;
        },
        // eslint-disable-next-line
        [],
    );

    /** 取得循環訂單可選購商品清單 */
    const getMemberCyclePurchaseProductsApi = useCallback(
        async () => {
            const resp = await Axios.get(GET_MEMBER_CYCLE_PURCHASE_PRODUCTS);
            return resp;
        },
        // eslint-disable-next-line
        [],
    );

    /**
     * 變更訂購口味
     * @param {{ cycleOrderID: number, items: Array<{ productID: number, variantID: number, quantity: number }> }} body
     */
    const postMemberCyclePurchaseChangeFlavorApi = useCallback(
        async (body) => {
            const resp = await Axios.post(POST_MEMBER_CYCLE_PURCHASE_CHANGE_FLAVOR, body);
            return resp;
        },
        // eslint-disable-next-line
        [],
    );

    /**
     * 取得循環訂單預約變更單（尚未生效）
     * @param {number} cycleOrderID
     */
    const getMemberCyclePurchasePendingChangesApi = useCallback(
        async (cycleOrderID) => {
            const resp = await Axios.get(GET_MEMBER_CYCLE_PURCHASE_PENDING_CHANGES(cycleOrderID));
            return resp;
        },
        // eslint-disable-next-line
        [],
    );

    /**
     * 取得循環變更單生效內容
     * @param {number} cycleOrderID
     * @param {number} effectID
     * @param {object} [options] 透傳給 useAxios 第三參數（例如 { isLoadingVisible: false }）
     */
    const getMemberCyclePurchaseEffectionApi = useCallback(
        async (cycleOrderID, effectID, options) => {
            const resp = await Axios.get(GET_MEMBER_CYCLE_PURCHASE_EFFECTION(cycleOrderID, effectID), undefined, options);
            return resp;
        },
        // eslint-disable-next-line
        [],
    );

    /**
     * 刪除預約變更單（須為未生效）
     * @param {number} effectID 變更單代碼
     */
    const deleteMemberCyclePurchaseEffectionApi = useCallback(
        async (effectID) => {
            const resp = await Axios.delete(DELETE_MEMBER_CYCLE_PURCHASE_EFFECTION(effectID));
            return resp;
        },
        // eslint-disable-next-line
        [],
    );

    return {
        getMemberCyclePurchaseListApi,
        getMemberCyclePurchaseProductsApi,
        postMemberCyclePurchaseChangeFlavorApi,
        getMemberCyclePurchasePendingChangesApi,
        getMemberCyclePurchaseEffectionApi,
        deleteMemberCyclePurchaseEffectionApi,
    };
};

export default useMemberCyclePurchaseApi;
